import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CmdbDigitalTermService } from './service/cmdb-digital-term.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-cmdb-digital-term',
	templateUrl: './cmdb-digital-term.component.html',
	styleUrl: './cmdb-digital-term.component.scss',
})
export class CmdbDigitalTermComponent implements OnInit {
	labels: LabelsInterface = {
		lbl_termo_responsabilidade_assinado_enviado: 'The responsibility document has already been signed and sent to your email.',
		lbl_caso_deseje_baixar_termo: 'If you wish to download the document',
		lbl_geral_clique_aqui: 'Click Here',
	};

	base64PDF: string | null = null;
	fileName: string | null = 'signature_term.pdf';
	isLoadingPage = true;

	constructor(
		private route: ActivatedRoute,
		private cmdbDigitalTermService: CmdbDigitalTermService,
		private LabelsService: LabelsService
	) {}

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
		});

		const uuid = this.route.snapshot.paramMap.get('uuid');

		if (uuid) {
			this.updateSignature(uuid);
		}
	}

	updateSignature(uuid: string): void {
		this.cmdbDigitalTermService.updateSignature(uuid).subscribe({
			next: (response) => {
				if (response) {
					this.base64PDF = response.pdf;
					this.fileName = response.fileName;
					this.isLoadingPage = false;
				}
			},
			error: (error) => {
				console.error('Erro ao confirmar a assinatura:', error);
			},
		});
	}

	downloadPDF(): void {
		if (this.base64PDF) {
			const link = document.createElement('a');
			link.href = `data:application/pdf;base64,${this.base64PDF}`;
			link.download = this.fileName;
			link.click();
		} else {
			console.error('PDF não disponível para download.');
		}
	}
}
